module.exports = __webpack_public_path__ + "img/IT0003124616764.36d1d30f.png";